var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "zoom-on-hover",
      on: {
        mousemove: _vm.move,
        mouseover: _vm.move,
        mouseenter: _vm.zoom,
        mouseleave: _vm.unzoom,
      },
    },
    [
      _c("img", {
        ref: "normal",
        staticClass: "normal lazyload",
        attrs: { "data-src": _vm.imgNormal },
      }),
      _vm._v(" "),
      _c("img", {
        ref: "zoom",
        staticClass: "zoom lazyload",
        attrs: { "data-src": _vm.imgZoom || _vm.imgNormal },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }